import { Skeleton } from '@mui/material';

const Loading = ({ width = 200, height = '1.5rem' }) => {
    return <Skeleton sx={{ width: width, height: height }} />;
};

export default Loading;
